import { Config } from '../../config'

export const onepointeConfig: Config = {
  partner: 'onepointe',
  catalog: 'partner',
  displayName: 'OnePointe',
  accentColor: '#1f76e2',
  host: 'chairs.onepointesolutions.com',
}

